import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { CommsService } from '@services';
import { CustomFormComponent } from '@services/formBuilder/abstract-custom-form-field';
import { IFolderCoreTarget } from '@modules/management/modules/folders/model/folders.interfaces';
import { ImageGalleryComponent, IGaleryImage } from '@shared/components';

import { cloneDeep, filter } from 'lodash';

@Component({
  selector: 'app-core-targets-picker',
  templateUrl: './core-targets-picker.component.html',
  styleUrls: ['./core-targets-picker.component.scss'],
})
export class CoreTargetsPickerComponent extends CustomFormComponent implements OnInit {
  public coreTargets: IFolderCoreTarget[] = [];
  // Thumbnail URLs precomputed per target (keyed by nfcID) — templates must not
  // call functions (project rule), so the src is resolved here, not in the view.
  public thumbUrls: { [nfcID: string]: string } = {};

  constructor(
    private commsService: CommsService,
    private modalController: ModalController
  ) {
    super();
  }

  ngOnInit() {
    // Seed local state from the value the FormBuilder set before it subscribed to
    // onChanged (see form-builder.service `customElement` branch) — reading here
    // does NOT emit, so the initial load is not counted as a change.
    this.coreTargets = cloneDeep(this.formValue) ?? [];
    this.buildThumbUrls();
  }

  // Open the placement photo in the shared lightbox (the same modal the
  // observation galleries use). No-op for targets without a photo.
  public async openImage(ctg: IFolderCoreTarget): Promise<void> {
    if (!ctg?.imageID) {
      return;
    }
    const image: IGaleryImage = {
      url: this.commsService.objectURI(ctg.imageID, false),
      thumbnailUrl: this.commsService.objectURI(ctg.imageID, true),
      title: ctg.name,
    };
    const modal = await this.modalController.create({
      component: ImageGalleryComponent,
      componentProps: { images: [image], index: 0 },
      cssClass: 'image-gallery-modal',
    });
    await modal.present();
  }

  public removeTarget(ctg: IFolderCoreTarget) {
    this.coreTargets = filter(this.coreTargets, (target) => target.nfcID !== ctg.nfcID);
    delete this.thumbUrls[ctg.nfcID];
    this.emitValue();
  }

  private buildThumbUrls(): void {
    this.thumbUrls = {};
    for (const ctg of this.coreTargets) {
      if (ctg.imageID) {
        this.thumbUrls[ctg.nfcID] = this.commsService.objectURI(ctg.imageID, true);
      }
    }
  }

  private emitValue() {
    // Stage the surviving list into the form's change tracking (marks dirty). No API call.
    this.formValue = [...this.coreTargets];
  }
}
